import  React,{useState,useEffect} from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Chip from "@mui/material/Chip"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import useApi from '../../api/useApi';
import { NewsLatestGet } from '../../api/orgService';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';

const StyledMenu = styled((props) => (

  
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: 'rgb(55, 65, 81)',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
        ...theme.applyStyles('dark', {
          color: 'inherit',
        }),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
    ...theme.applyStyles('dark', {
      color: theme.palette.grey[300],
    }),
  },
}));

export default function LatestNewsNav({recolor}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate()
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [latestNews,setLatestNews] = useState({})

    const { request: getLatestNews, data:newsData, error:categoryError,isLoading} = useApi(NewsLatestGet);
    
    useEffect(() => {
      getLatestNews()
          // eslint-disable-next-line
    }, []);

    useEffect(()=>{
        getLatestNews()
      
    },[])
    
    // useEffect(()=>{
    //   if(location?.state?.refresh==="category"){
    //     getLatestNews()
    //   }
    // },[location?.state])
       
    useEffect(() => {
      console.log(newsData)
        if(newsData?.data){
          setLatestNews(newsData?.data)
        }
        // eslint-disable-next-line
    }, [newsData]);
               
    useEffect(()=>{
        if(categoryError){
            toast.error(`${JSON.stringify(categoryError?.response?.data,null,2)}`,{position: "top-center"});
      }
    },[categoryError])

    const insertBreak = (text, wordIndex) => {
      const words = text?.split(" ");
      return (
        <>
          {words?.slice(0, wordIndex).join(" ")}  
          <br />
          {words?.slice(wordIndex).join(" ")}
        </>
      );
    };

    const handleChipClick = () => {
      const url = latestNews?.link;
      const myDomain = "fountainafrica.org";
    
      if (url?.includes(myDomain)) {
        // internal link → use react-router
        navigate(url);
      } else {
        // external link → open in new tab
        window.open(url, "_blank", "noopener,noreferrer");
      }
    };

  return (
    <div>
      <Button
        id="demo-customized-button"
        sx={{
          color: `${recolor?'#ffff':'#1565c0'}`,
          fontWeight: 600,
          fontSize:15,
          textTransform: 'none',
          '&:hover': {
            backgroundColor: 'transparent',
            color: `${recolor?'#c18078':'#1565c0'}`,
          },
          // marginLeft:3,
          // margingRight:2,
        // padding:2,
        }}
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="text"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        secondary
      >
        Latest News
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        slotProps={{
          list: {
            'aria-labelledby': 'demo-customized-button',
          },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
         <div class="latest-news-container">
            {/* <!-- Card Thumbnail --> */}
            <div 
            class="latest-news-card" 
            style={{
              backgroundImage: `url(${latestNews?.image})`,
              backgroundSize: "cover",
              backgroundPosition: "center"}}
            >
                {/* <h2>birthwise</h2>
                <p>{insertBreak(latestNews?.title, 3)}</p> */}
                <div className="latest-overlay">
                  <p className="nav-latest-title-text">
                    {/* {insertBreak(latestNews?.title, 3)} */}
                  </p>
              </div>
            </div>

            {/* <!-- Menu Items --> */}
            <div class="latest-news-menu">
                
                <p>{latestNews?.description}</p>
                <p style={{overflow:'hidden'}}>{latestNews?.subtitle}</p>
                {/* <p>Styles for headings, paragraphs, lists...etc</p> */}
                <Chip
                  label="Follow Story"
                  onClick={handleChipClick}
                  color="primary"
                  variant="outlined"
                  size="small"
                  style={{ marginTop: "12px" }}
                />
            </div>
        </div>
      </StyledMenu>
    </div>
  );
}